import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { GenericFilter } from 'projects/shared/src/lib/models/GenericFilter';
import { SubTenantDto, TenantDto, TenantGroupRoleDto, TenantGroupRoleUserDto, TenantScope, UserTenantDto } from 'projects/shared/src/lib/models/TenantDto';
import { UserDto } from 'projects/shared/src/lib/models/User';
import { AccountService } from 'projects/shared/src/lib/services/account.service';
import { NotificationService } from 'projects/shared/src/lib/services/notification.service';
import { OAuthServiceService } from 'projects/shared/src/lib/services/o-auth-service.service';
import { TenantService } from 'projects/shared/src/lib/services/tenant.service';
import { TranslateService } from 'projects/shared/src/lib/services/translate.service';
import { debounceTime, finalize, switchMap, tap } from 'rxjs';
import { GeneralUtils } from "projects/admin/src/lib/modules/shared/utils/general-utils";
import { Clipboard } from '@angular/cdk/clipboard';


@Component({
  selector: 'tenant-dialog',
  templateUrl: './add-tenant-dialog.component.html',
  styleUrls: ['./add-tenant-dialog.component.scss']
})
export class AddTenantDialogComponent implements OnInit {

  tenantForm!:FormGroup;
  userTenant!:UserTenantDto;
  _db!:string;
  scopes:TenantScope[] = [];
  scope!:TenantScope;
  selectedScope!:TenantScope;
  selectedUserEmail!:string;
  isLoading = true;
  scopeSelected = false;
  userSelected = false;
  users:UserDto[] = [];
  user!:UserDto;
  filter!: GenericFilter;
 
  constructor(private fb: FormBuilder,
    public _dialogRef: MatDialogRef<AddTenantDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public translate: TranslateService,
    private notificationService: NotificationService,
    private oauthService: OAuthServiceService,
    private tenantService: TenantService,
    private accountService: AccountService,
    private clipboard: Clipboard
    ) { }

  ngOnInit(): void {

    // this.oauthService.userData.subscribe({
    //   next: (data) => {
    //     if (typeof data != undefined && data != null) {
    //       let userRoles = data.role as Array<string>;
    //       userRoles.forEach((dbrole: string) => {
    //         if (dbrole === 'admin') {
    //          this._db = dbrole;
    //         }
    //       });
    //     }
    //   }
    // });

    this.createTenantForm();

    this.searchData();

  }

  createTenantForm() {
    let emailregex: RegExp = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    this.tenantForm = this.fb.group({
      name:[null],
      responsibleUser: [null, [Validators.pattern(emailregex), Validators.required]],
      wpServerUrl: [null],
      wpTenantName: [null],
      wpApiKeyInbound: [GeneralUtils.generateGuid()],
      wpApiKey: [null],
      wpApiUser: [null],
      // name:[null, Validators.required],
      // responsibleUser: [null, [Validators.pattern(emailregex), Validators.required]],
      // wpServerUrl: [null, Validators.required],
      // wpTenantName: [null, Validators.required],
      // wpApiKey: [null, Validators.required],
    });
  }

  searchData() {
    this.filter = new GenericFilter();
    let searchText = "";
    this.accountService.getAllUsers(searchText, 1, 10000).subscribe({
      next: (users) => {
        this.users = users;
        console.log("------------> users: ", this.users);
        this.tenantService.getScopes(this.tenantService.currentTenantName).subscribe({
          next:(scopes) => {
              // this.isLoading = false;
              this.scopes = scopes;
              console.log("============> scopes: ", this.scopes)
              // this.createTenantForm();
            },
            //error: (error: any) => this.notificationService.error(`${this.translate.data["ERROR"]}`, `${this.translate.data["PROJECTCLONEDERROR"]}`)
        })   
      },
      error: (error: any) => {
        // this.isLoadingResults = false;
        // this.isRateLimitReached = true;
        this.notificationService.error(`${this.translate.data["ERROR"]}`, `${this.translate.data["USERRETRIVALERROR"]}`)
      }
    });

    this.tenantForm.get('responsibleUser')?.valueChanges
      .pipe(debounceTime(300),
        tap(() => this.isLoading = true),
        switchMap((value: any) => this.accountService.getAllUsers(value, 1, 10000)
          .pipe(finalize(() => this.isLoading = false))))
      .subscribe({
        next: (userDto: UserDto[]) => {
          this.users = userDto;
          //this.notificationService.info(`${this.translate.data["INFO"]}`, `${this.translate.data["USERFOUND"]} `);
        },
        error: (error: any) => this.notificationService.error(`${this.translate.data["ERROR"]}`, `${this.translate.data["USERFOUNDERROR"]}`)
      });
   
    }

  add() {
      // console.log("------------> add-tenant-dialog: tenantForm = ", this.tenantForm);
      // console.log("------------> add-tenant-dialog: tenantName = ", this.tenantForm.value.name);
      // console.log("------------> add-tenant-dialog: selected scope = ", this.selectedScope);
      // console.log("------------> add-tenant-dialog: verantw. User = ", this.tenantForm.value.responsibleUser);


    let tenantName = "";
    if(this.selectedScope.systemtype === "WINPLAN") {
      let wpUrl = GeneralUtils.toComfortableUrlString(this.tenantForm.value.wpServerUrl);
      let wpTenantName = GeneralUtils.toComfortableTenantName(this.tenantForm.value.wpTenantName);
      tenantName = wpUrl + "_" + wpTenantName;
    } else {
      tenantName = this.tenantForm.value.name
    }

    this.tenantService.isTenantExisting(tenantName).subscribe({
      next: (tenantExists) => {
        if(tenantExists) {
          this.notificationService.error(`${this.translate.data["WARN"]}`, `${"Der Mandant {t} existiert bereits!".replace("{t}", tenantName)}`);
          return;
        } else {
          this.notificationService.wait(undefined, "Neuer Mandant wird angelegt ....");

          if(tenantName != "" && this.selectedScope != null && this.tenantForm.value.responsibleUser != null) {
            let tenant = new TenantDto;
            tenant.name = tenantName;
            tenant.scopeName = this.selectedScope.name;
            tenant.frontendUrl = this.selectedScope.frontendurl;
            tenant.systemType = this.selectedScope.systemtype;
            tenant.wpApiKeyInbound = this.tenantForm.value.wpApiKeyInbound;
            tenant.wpServerUrl = this.tenantForm.value.wpServerUrl;
            tenant.wpApiUser = this.tenantForm.value.wpApiUser;
            tenant.wpApiKey = this.tenantForm.value.wpApiKey;
            tenant.wpTenantName = this.tenantForm.value.wpTenantName;
      
            console.log("------------> add-tenant-dialog: tenant = ", tenant);
            //console.log("------------> add-tenant-dialog: selected user = ", this.tenantForm.value.responsibleUser);

            this.createTenantDbAndTenantAdmin(tenant)       
            //this._dialogRef.close(tenant);
          }
       }
      },
      error: (error: any) => {}
    });

  }

  displayFn(user: any) {
    console.log("displayFn: user = ", user)
    if (user) { return user; }
  }

  cancel() {
    this._dialogRef.close();
  }

  isFormValid() {
    // console.log("------------> isFormValid: tenantForm = ", this.tenantForm.value.name); 
    // console.log("------------> isFormValid: selectedScope = ", this.selectedScope);
    // console.log("------------> isFormValid: userSelected = ", this.userSelected);
    // console.log("------------> isFormValid: tenantForm = ", this.tenantForm.valid);
    // console.log("------------> isFormValid: responsibleUser = ", this.tenantForm.value.responsibleUser);
    // console.log("------------> ----------------------------------------------------------");
    // return this.tenantForm.value.name && this.selectedScope && (this.userSelected || this.tenantForm.value.responsibleUser) && this.tenantForm.valid;
    return (this.selectedScope 
              && (this.tenantForm.value.name && this.selectedScope.systemtype !== "WINPLAN") || (this.tenantForm.value.wpServerUrl && this.tenantForm.value.wpTenantName  && this.selectedScope.systemtype === "WINPLAN"))
              && (this.tenantForm.value.wpApiKey || this.selectedScope.systemtype !== "WINPLAN")
              && (this.userSelected || this.tenantForm.value.responsibleUser);
  }

  optionUserSelected(event: any) {
    this.user = event.option.value;
    console.log("------------> selected user = ", this.user);
    this.userSelected = true;
    this.selectedUserEmail = this.user.email;
  }

  createTenantDbAndTenantAdmin(tenant:TenantDto) {
    this.tenantService.createTenancy(tenant).subscribe({
      next:(tenant:TenantDto) => {
        console.log("------------> createTenantDbAndTenantAdmin: tenant = ", tenant);
        if(tenant.name == null) {
          this.notificationService.error(`${this.translate.data["ERROR"]}`, "Mandant konnte nicht angelegt werden, weil das .fdb File noch existiert und gelockt ist!");
          this.notificationService.info("", "Nach Neustart des Servers kann der Mandant angelegt werden!");
          return;
        }
        console.log("------------> createTenantDbAndTenantAdmin: ", tenant);
        this._dialogRef.close(tenant);
        this.createAdminTenantGroupRole(tenant);
        this.notificationService.success(`${this.translate.data["SUCCESS"]}`, `${this.translate.data["TENANTADDED"]}`);
      },
      error: (error: any) => {
        this.notificationService.error(`${this.translate.data["ERROR"]}`, `${this.translate.data["TENANTADDEDERROR"]}`);
        this.notificationService.info("", error.error.developerMessage.Message)
        console.log("------------> add-tenant-dialog: ", error.error.developerMessage);
   }
    })
  }

  createAdminTenantGroupRole(tenant:TenantDto) {
    let tenantGroupRole = new TenantGroupRoleDto;
    tenantGroupRole.name = "Administrator"
    tenantGroupRole.displayName = "Administrator";
    tenantGroupRole.permissions = "CREATE_USER,MANAGE_USERS,CREATE_PROJECT,MANAGE_PROJECTS,CREATE_APITOKEN,CREATE_OWN_APITOKEN,MANAGE_AUDIT)";

    this.tenantService.createTenantGroupRole(tenant.name, tenantGroupRole).subscribe({
      next: (tenantGroupRole) => {
        console.log("------------> createTenantGroupRole: ", tenantGroupRole);
        this.createTenantAdminUser(tenant, tenantGroupRole);
      },
      error: (error: any) => this.notificationService.error(`${this.translate.data["ERROR"]}`, `${this.translate.data["PLATFORMGROUPROLEADDEDERROR"]}`)
    });

  }

  createTenantAdminUser(tenant:TenantDto, tenantGroupRole:TenantGroupRoleDto) {
    let adminUser = new UserDto();
    let undefinedCopyUser = "undefined";
    adminUser.userName = this.tenantForm.value.responsibleUser.email;
    adminUser.email = this.tenantForm.value.responsibleUser.email;
    console.log("------------> createTenantAdminUser: ", adminUser);
    this.accountService.createUser(adminUser, /*isTenantAdmin:*/true, undefinedCopyUser, tenant.name, tenant.id).subscribe({
      next: (user) => {
        console.log("------------> createTenantAdminUser: ", user);
        this.assignGroupRoleToTenantAdmin(tenant, tenantGroupRole, user);
      },
      error: (error: any) => this.notificationService.error(`${this.translate.data["ERROR"]}`, `${this.translate.data["USERADDEDERROR"]}`)
    });

  }

  assignGroupRoleToTenantAdmin(tenant:TenantDto, role:TenantGroupRoleDto, user:UserDto) {
    let tenantGroupRoleUser = new TenantGroupRoleUserDto;
    tenantGroupRoleUser.roleId = role.id;
    tenantGroupRoleUser.name = role.name;
    tenantGroupRoleUser.userId = user.id;
    tenantGroupRoleUser.userName = user.userName;
    this.tenantService.createTenantGroupRoleUser(tenant.name, tenantGroupRoleUser).subscribe({
      next: (tenantGroupRoleUser) => {
        console.log("------------> createTenantGroupRoleUser: ", tenantGroupRoleUser);
      },
      error: (error: any) => this.notificationService.error(`${this.translate.data["ERROR"]}`, `${this.translate.data["PLATFORMGROUPROLEADDEDERROR"]}`)
    });
  }

  copy(){
    let tenantName = "";
    let text = "";
    if(this.selectedScope.systemtype === "WINPLAN") {
      let wpUrl = GeneralUtils.toComfortableUrlString(this.tenantForm.value.wpServerUrl);
      let wpTenantName = GeneralUtils.toComfortableTenantName(this.tenantForm.value.wpTenantName);
      tenantName = wpUrl + "_" + wpTenantName;
      text = "Mandanten Name: " + tenantName + "\n" +
                "Admin: " + this.tenantForm.value.responsibleUser.email + "\n" +
                "WP Server Url: " + this.tenantForm.value.wpServerUrl + "\n" +
                "WP Mandant: " + this.tenantForm.value.wpTenantName + "\n" +
                "WP API Key Inbound: " + this.tenantForm.value.wpApiKeyInbound + "\n" +
                "WP API User: " + this.tenantForm.value.wpApiUser + "\n" +
                "WP API Key: " + this.tenantForm.value.wpApiKey + "\n";
    } else {
      tenantName = this.tenantForm.value.name
      text = "Mandanten Name: " + tenantName + "\n" +
                "Admin: " + this.tenantForm.value.responsibleUser.email + "\n" +
                "WP Server Url: nicht vorhanden\n" +
                "WP Mandant: nicht vorhanden\n" +
                "WP API User: nicht vorhanden\n" +
                "WP API Key: nicht vorhanden\n" +
                "WP API Key Inbound: nicht vorhanden\n";
    }
    this.clipboard.copy(text);
    this.notificationService.info("", "Mandanten Informationen wurden in die Zwischenablage kopiert!");
  }

}
